// src/components/FloatingContactButton.jsx

const FloatingContactButton = () => {
  const handleClick = () => {
    // Example: scroll to contact section
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      className="floating-contact"
      id="floatingContactBtn"
      aria-label="Contact"
      onClick={handleClick}
    >
      <span className="icon">✉️</span> Contact
    </button>
  );
};

export default FloatingContactButton;
